<template>
  <div class="product-bar-item">
    <div
      v-for="(product, i) in products"
      :key="i"
      class="product-bar-item__product-wrapper"
      @click="showCard(product)"
    >
      <!-- transitionDelay: (0.09 * i) + 's' -->
      <!-- :class="{ 'slide-up': productMotion, 'slide-out': !productMotion }" -->
      <div class="product-bar-item__product-wrapper__icon" :class="{ active: product.isActive }">
        <img :class="{ 'rise-up': product.isActive && raiseIcon }" :src="getIcon(product.icon)" alt />
      </div>
      <div class="product-bar-item__product-wrapper__text">
        <p class="font">{{ product.name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  name: "product-item",
  data() {
    return { timeout: undefined };
  },
  methods: {
    ...mapMutations([
      "updateShowProductCard",
      "updateShowButtons",
      "updateShowProductCard",
      "updatePreviousProductId",
      "setDelay",
      "updateCurrentProductId",
      "updateShowAmbientAnimations",
      "clearMicroAnimationsPlaying"
    ]),
    ...mapActions([
      "findProductCard",
      "removeFirstProductCard",
      "findProductIconsToReveal",
      "removeProductIconsToReveal"
    ]),
    showCard(product) {
      this.clearMicroAnimationsPlaying();
      this.setDelay(false);
      setTimeout(() => {
        if (this.animationPlaying === false) {
          if (product.id === this.previousProductId) {
            this.updateShowAmbientAnimations(true);

            setTimeout(() => {
              this.updateShowProductCard(false);
            }, 0);
            this.updateCurrentProductId(null);
            this.updateShowButtons(true);
            this.removeFirstProductCard();
            this.removeProductIconsToReveal(this.previousProductId);
            this.updatePreviousProductId(null);
            return;
          }
          this.updateShowAmbientAnimations(false);
          this.findProductCard(product.id);
          this.updateCurrentProductId(product.id);
          this.updateShowProductCard(true);
          setTimeout(() => {
            this.updateShowButtons(false);
          }, 0);
          this.findProductIconsToReveal(product.id);
          if (this.productCards.length === 2) {
            this.removeFirstProductCard();
            this.removeProductIconsToReveal(this.previousProductId);
          }
          this.updatePreviousProductId(product.id);
        }
      }, 0);
    },
    getIcon(pic) {
      if (pic) {
        var image = require.context("@/assets/product-bar-assets/", false);
        return image("./" + pic);
      }
    }
  },
  computed: {
    ...mapState({
      products: state => state.productBar.products,
      productCards: state => state.productBar.productCards,
      previousProductId: state => state.productBar.previousProductId,
      raiseIcon: state => state.productBar.raiseIcon,
      animationPlaying: state => state.moduleMacroAnimations.animationPlaying,
      productMotion: state => state.productBar.productMotion
    })
  }
};
</script>

<style scoped lang="scss">
@import "../styles/_vars";
.product-bar-item {
  position: fixed;
  bottom: 0;
  width: 100vw;
  height: 1.5vw;
  @media screen and (max-aspect-ratio: 256/135) {
    height: 3.5vw;
  }
  z-index: 10;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-content: center;
  align-items: center;
  &__product-wrapper {
    cursor: pointer;
    height: 100%;
    width: 12%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center;
    &__icon {
      position: relative;
      width: 1.5vw;
      @media screen and (max-aspect-ratio: 256/135) {
        width: 3vw;
      }
      height: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: center;
      align-content: center;
      align-items: center;
      border-bottom: solid black 2px;
      transition: border-bottom $transition-duration;
      img {
        margin-top: 2px;
        width: 1vw;
        height: 1vw;
        @media screen and (max-aspect-ratio: 256/135) {
          width: 1.5vw;
          height: 1.5vw;
        }
        transition: transform $transition-duration;
      }
      &::after {
        transition: opacity $transition-duration, height $transition-duration;
        opacity: 0;
        position: absolute;
        height: 100%;
        width: 100%;
        content: "";
        background-image: linear-gradient(
          to top,
          rgba(white, 0.25),
          rgba(white, 0)
        );
      }
    }
    &__text {
      color: $color-white;
      margin-left: 0.5vw;
      font-size: 0.3vw;
      width: 45%;
      @media screen and (max-aspect-ratio: 256/135) {
        margin-left: 0.2vw;
        font-size: 0.5vw;
        width: 45%;
      }
    }
  }
}
.active {
  border-bottom: solid $color-white 2px;
  transition: border-bottom $transition-duration;
  position: relative;

  &::after {
    transition: opacity $transition-duration, height $transition-duration;
    opacity: 1;
    position: absolute;
    height: 170%;
    width: 100%;
    content: "";
    background-image: linear-gradient(
      to top,
      rgba(white, 0.25),
      rgba(white, 0)
    );
  }
}
.rise-up {
  transform: translateY(-70%);
}
</style>
